import React from 'react';

const NoAccess = () => <div className="text-danger">You Are not allowed to access this page.</div>;

export default NoAccess;